// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__mg_cR","iconRight":"Button_iconRight__U10Cp","small":"Button_small__uAK9I","ghost":"Button_ghost__VE_C_","outlined":"Button_outlined__60faD"};